import * as React from "react";

const LinkAddCircleHover: React.FC = () => {
    return (
        <svg
            width="12px"
            height="12px"
            viewBox="0 0 12 12"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        ></svg>
    );
};

export default React.memo(LinkAddCircleHover);
